import {FC} from 'react'
import {FormAvailability} from '../components/Forms/FormAvailability'

const HeaderAvailabilityPanel: FC = () => {
  return (
    <>
      <FormAvailability />
    </>
  )
}

export {HeaderAvailabilityPanel}
